<app-timeout></app-timeout>
<div class="container-fluid app-content-view">
  @if (isUserAuthorized) {
    <div class="AuthCheck">
      <div class="opm-cm-container">
        <form>
          <table class="cm-grid">

            <tbody>
              <tr>
                <td class="field">Application Name</td>
                <td class="field">GEO</td>
                <td class="field">Environment</td>
                <td class="field">MemberFirm Code</td>
                <td class="field"></td>
              </tr>
              <tr>
                @if (isLoaded) {
                  <td class="value">
                    <ng-select class="mf-ng-select"
                               [items]="appcode"
                               bindLabel="name"
                               placeholder="Select Application"
                               appendTo="body"
                               multiple="true"
                               [maxSelectedItems]="3"
                               [clearable]="true"
                               [(ngModel)]="selectedappcode">
                    </ng-select>
                  </td>
                }
                @if (isLoadedgeo) {
                  <td class="value">
                    <div class="geodropdown">
                      <ng-select class="geo-mf-ng-select"
                                 [items]="geocode"
                                 bindLabel="name"
                                 placeholder="Select GEO"
                                 appendTo="body"
                                 multiple="true"
                                 (change)="loadmf($event)"
                                 [maxSelectedItems]="1"
                                 [(ngModel)]="selectedgeo">
                      </ng-select>
                    </div>
                  </td>
                }
                <td class="value">
                  @if (isDEV) {
                    <select disabled>
                      <option value=1>DEV</option>
                    </select>
                  }
                  @if (isQA) {
                    <select disabled>
                      <option value=1>QA</option>
                    </select>
                  }
                  @if (isLOAD) {
                    <select disabled>
                      <option value=1>LOAD</option>
                    </select>
                  }
                  @if (isSTAGE) {
                    <ng-select [items]="environment"
                               bindLabel="name"
                               placeholder={{selectedenv.name}}
                               [clearable]="false"
                               appendTo="body"
                               (change)="loadmfforstage($event)"
                               [(ngModel)]="selectedenv">
                    </ng-select>
                  }
                </td>
                <td class="value" [ngClass]="isLoaded1 ? 'notSelected' : 'Selected'">
                  <ng-select #ngselectmf class="mf-ng-select"
                             [items]="mfcodeobs$ | async"
                             bindLabel="name"
                             placeholder="Select Memberfirm Code"
                             appendTo="body"
                             multiple="true"
                             [maxSelectedItems]="3"
                             [(ngModel)]="selectedmf">
                  </ng-select>
                </td>
                <td class="value" style="width:70px">
                  <button (click)="getvalues()"
                          [disabled]="!isFormValid()">
                    Submit
                  </button>
                </td>
                <td class="value" style="width:70px">
                  <button (click)=" routeToBaseMapping()">
                    View Base Mappings
                  </button>
                </td>
                <td class="value" style="width:70px">
                  <button (click)="getAllcontainermappings()">
                    Export All Mappings
                  </button>
                </td>
                <td class="value" style="width:70px">
                  <button (click)=" routeToAppView()">
                    View Onboarded Apps
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
      @if (!!gridDataModel && !visiblNoMatchesFoundPopup) {
        <div class="search-results-container">
          @if (isPagingVisible) {
            <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                        (pageChanged)="onPageChange($event)">
            </opm-paging>
          }

          @switch (gridResult) {
            @case (gridResultEnum.Containermapping) {
              <opm-grid [metaName]="gridTypeEnum.Containermapping" [containerMapping]="containerMapingModel.ContainerMappingDetails" [users]="gridDataModel.ContainerMappingDetails"></opm-grid>
            }
          }

          @if (isPagingVisible) {
            <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                        (pageChanged)="onPageChange($event)">
            </opm-paging>
          }
        </div>
      }

      @if (visiblNoMatchesFoundPopup) {
        <opm-modal-popup header="Container Mappings" [cancelVisibility]="false"
                         message="{{noMatchesFoundMsg}}" okButtonName="Ok" (onOk)="gridDataModel = null; visiblNoMatchesFoundPopup = false">
        </opm-modal-popup>
      }
    </div>
  }

  @if (!isUserAuthorized) {
    <div class="user-unauthorized">{{errorMessage}}</div>
  }
</div>
<opm-footer></opm-footer>
